// Initialise Digital Data Object.
export const _satellite: any = {};
export const digitalData: any = {};
digitalData.page = digitalData.page || {}; 				// Information of the page access by consumer
digitalData.product = digitalData.product || {}; 				// Information of product accees or purchesed by consumer.
digitalData.consumer = digitalData.consumer || {}; 				// Information about the consumer
digitalData.transaction = digitalData.transaction || {};				// Information of Order or application made by consumer.
digitalData.event = digitalData.event || {};				// ClickStream events made by consumer.
digitalData.system = digitalData.system || {};              //contain the information which provided by the system not fill by user.

// To be invoked on every page load. Initialises page section of data layer object.
export function initiPageInfo(siteSection, siteSubSection, server, productId, productName, consumerType, applicationKey, applicantKey, nextTaskKey,sourceChannel,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
        digitalData.consumer = digitalData.consumer || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.version = "v1.0",
            digitalData.page.siteSection = siteSection || "",
            digitalData.page.siteSubSection = siteSubSection || "",
            digitalData.page.server = server || "",
            digitalData.product.productId = productId || "",
            digitalData.consumer.type = consumerType || ""
            digitalData.product.productName = productName || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventId = "pageInitialization",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
            digitalData.event.eventContext.partnerSource = 'finvu' || "", // partnersource
            digitalData.event.eventContext.bankName = bankName || "",  //bank name
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "", // transaction id

        callStatellite("omnichannel-init-pageload");
    }
    catch (err) { }
}

//To be clicked when user click on proceed button on account aggrgator page
export function accountaggregatorProceed(applicationKey, applicantKey, nextTaskKey, productId,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.product.productId = productId || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventId = "account aggragator proceed",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.partnerSource = 'finvu' || "", // partnersource
            digitalData.event.eventContext.bankName = bankName || "",  //bank name
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "", // transaction id
            callStatellite("account-aggregator-proceed")
    }
    catch (err) { }
}

//To be clicked when user click on verify button after entering otp
export function finvuotpVerify(applicationKey, applicantKey, nextTaskKey, productId, OTPstatus, sourceChannel, ctaText,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.product.productId = productId || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventContext.OTPstatus = OTPstatus || "",
            digitalData.event.eventId = "finvu otp verify",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
            digitalData.event.eventContext.ctaText="" || ctaText,
            digitalData.event.eventContext.partnerSource = 'finvu' || "", // partnersource
            digitalData.event.eventContext.bankName = bankName || "",  //bank name
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "", // transaction id
            callStatellite("finvu-otp-verify");
    }
    catch (err) { }
}

//To be clicked when user click on approve button after selecting a bank
export function bankselectionapproveClick(applicationKey, applicantKey, nextTaskKey, productId, providerName,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.product.productId = productId || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventContext.providerName = providerName || "",
            digitalData.event.eventId = "bank selection approve click",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.partnerSource = 'finvu' || "", // partnersource
            digitalData.event.eventContext.bankName = bankName || "",  //bank name
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "", // transaction id
            callStatellite("bank-selection-approve-click");
    }
    catch (err) { }
}

//To be clicked when user click on proceed button after selecting a bank account
export function bankaccountselectionProceed(applicationKey, applicantKey, nextTaskKey, productId, sourceChannel, ctaText,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact=digitalData.consumer.contact||{},
            digitalData.product.productId = productId || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
            digitalData.event.eventContext.ctaText = "" || ctaText,
            digitalData.event.eventId = "bank account selection proceed",
            digitalData.event.eventContext.partnerSource = 'finvu' || "", // partnersource
            digitalData.event.eventContext.bankName = bankName || "",  //bank name
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "", // transaction id
            callStatellite("bank-account-selection-proceed")
    }
    catch (err) { }
}

//To be clicked when user click on approve buttion on confirmation page
export function accountapproveClick(applicationKey, applicantKey, nextTaskKey, productId, sourceChannel, ctaText,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.product.productId = productId || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventId = "account approve click",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
            digitalData.event.eventContext.ctaText = "" || ctaText,
            digitalData.event.eventContext.partnerSource = 'finvu' || "",
            digitalData.event.eventContext.bankName = bankName || "",
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "",
            callStatellite("account-approve-click")
    }
    catch (err) { }
}

//this function will fire when user click on any cta 
export function allctaInteraction(componentName, ctaText, productId, sourceChannel,applicantKey,guestId,userType,transactionId,bankName) {
    try {
        digitalData.consumer = digitalData.consumer || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.product = digitalData.product || {};
            digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.event.eventContext.ctaText = "" || ctaText,
            digitalData.event.eventContext.componentName = componentName || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.product.productId = productId || "",
            digitalData.event.eventId = "all cta interaction",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
            digitalData.event.eventContext.partnerSource = 'finvu' || "",
            digitalData.event.eventContext.bankName = bankName || "",
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "",
            callStatellite('all-cta-interaction');
    } catch (er) { }
}

//when back is pressed
export function backButton(applicationKey, applicantKey, currentStage, nextStage, productId,guestId,userType,transactionId,bankName) {
    digitalData.event.eventContext = digitalData.event.eventContext || {},
    digitalData.consumer.contact = digitalData.consumer.contact || {},
        digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.product.productId = productId || "",
        digitalData.event.eventContext.currentStage = currentStage || ""
        digitalData.system.nextStage = nextStage || "",
        digitalData.event.eventId = "back button click",
        digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
        digitalData.event.eventContext.partnerSource = 'finvu' || "",
        digitalData.event.eventContext.bankName = bankName || "",
        digitalData.consumer.guestId = guestId || "",                 //updated guest id
        digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
        digitalData.consumer.userType = userType || "",               //updated user type
        digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
        digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
        digitalData.consumer.transactionId = transactionId || "",
        callStatellite("omnichannel-back-button-click")
}

//fire this function on the page load of consent approval
export function consentapprovalpageLoad(applicationKey, applicantKey, nextTaskKey, productId, consentStatus, sourceChannel,guestId,userType,transactionId,bankName) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.consumer = digitalData.consumer || {},
            digitalData.consumer.contact = digitalData.consumer.contact || {},
            digitalData.product.productId = productId || "",
            digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
            digitalData.consumer.applicantKey = applicantKey || "",
            digitalData.system.nextTaskKey = nextTaskKey || "",
            digitalData.event.eventContext.consentStatus = consentStatus || "",
            digitalData.event.eventId = "consent approval page load",
            digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
            digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
            digitalData.event.eventContext.partnerSource = 'finvu' || "",
            digitalData.event.eventContext.bankName = bankName || "",
            digitalData.consumer.guestId = guestId || "",                 //updated guest id
            digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
            digitalData.consumer.userType = userType || "",               //updated user type
            digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
            digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
            digitalData.consumer.transactionId = transactionId || "",
            callStatellite("consent-approval-page-load")
    }
    catch (err) { }
}

//when user interacted with any input field
export function inputfieldInteraction(fieldName, productId) {
    try {
        digitalData.event.eventContext = digitalData.event.eventContext || {},
            digitalData.event.eventContext.fieldName = fieldName || "",
            digitalData.product.productId = productId || "",
            digitalData.event.eventName = 'input field interaction',
            callStatellite('input-field-interaction')
    }
    catch (err) { }
}

// common function for _satellite
export const callStatellite = (eventName) => {
    try {
        setTimeout(() => {
            _satellite.track(eventName);
        }, 0);
    } catch (error) { }

};
export function resendOtpClick(applicationKey, applicantKey, nextTaskKey, productId, sourceChannel, OTPstatus, ctaText,guestId,userType,transactionId,bankName) {
    try{ 
        digitalData.event.eventContext = digitalData.event.eventContext || {},    
        digitalData.consumer = digitalData.consumer || {},
        digitalData.consumer.contact = digitalData.consumer.contact || {},
        digitalData.product.productId = productId || "",   
        digitalData.consumer.applicationKey = sessionStorage.getItem("applicationid") || "",
        digitalData.consumer.applicantKey = applicantKey || "",
        digitalData.system.nextTaskKey = nextTaskKey || "",
        digitalData.event.eventId = "resendOtpClick",
        digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
        digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
        digitalData.event.eventContext.OTPstatus = OTPstatus || "",
        digitalData.event.eventContext.ctaText = "" || ctaText,
        digitalData.event.eventContext.partnerSource = 'finvu' || "",
        digitalData.event.eventContext.bankName = bankName || "",
        digitalData.consumer.guestId = guestId || "",                 //updated guest id
        digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
        digitalData.consumer.userType = userType || "",               //updated user type
        digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
        digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
        digitalData.consumer.transactionId = transactionId || "",
    callStatellite("resendOtpClick")
      }
   catch (err) { }
}

export function verifyAccountAuthorize(applicationKey, applicantKey, nextTaskKey, productId, sourceChannel, OTPstatus, ctaText,guestId,userType,transactionId,bankName){			//Function for bank page load
    try{ 
    digitalData.event.eventContext=digitalData.event.eventContext||{},    
    digitalData.consumer=digitalData.consumer||{},
    digitalData.consumer.contact = digitalData.consumer.contact || {},
    digitalData.product.productId=productId||"",   
    digitalData.consumer.applicationKey=sessionStorage.getItem("applicationid")||"",
    digitalData.consumer.applicantKey=applicantKey||"",
    digitalData.system.nextTaskKey=nextTaskKey||"",
    digitalData.event.eventContext.OTPstatus = OTPstatus || "", 
    digitalData.event.eventId="verify-account-authorize",
    digitalData.event.eventContext.sourceChannel = sessionStorage.getItem("sourceChannel") || "AA",
    digitalData.event.eventContext.productId = sessionStorage.getItem("productid") || sessionStorage.getItem('occupationIdentifier') || "",
    digitalData.event.eventContext.ctaText = "" || ctaText,
    digitalData.event.eventContext.partnerSource = 'finvu' || "",
    digitalData.event.eventContext.bankName = bankName || "",
    digitalData.consumer.guestId = guestId || "",                 //updated guest id
    digitalData.consumer.customerId = sessionStorage.getItem('finvucustomerid') || "",           //updated  customer id
    digitalData.consumer.userType = userType || "",               //updated user type
    digitalData.consumer.applicantId = sessionStorage.getItem("applicantid") || "",         //updated applicant id,
    digitalData.consumer.contact.mobileNo = sessionStorage.getItem("mob") || "",
    digitalData.consumer.transactionId = transactionId || "",
    callStatellite("verify-account-authorize")
      }
   catch(err){}
}